var twig = require("twig").twig,
    tokens = [{"type":"raw","value":"<input (input) type=\"date\">"}],
    template = twig({"id":"$resolved:d228439361bfaf00ccddb0393d2cdb5cc1bcc35e76685bf9e8878e1cf2e5a82c91bf03e9f6d3ef891274d5e1238811b45be01aedcfd1ad5c1ebaa3120e00fc34:magic-input-date.twig","data":[{"type":"raw","value":"<input (input) type=\"date\">"}],"allowInlineIncludes":true,"rethrow":true});

module.exports = function(context) { return template.render(context); }

module.exports.tokens = tokens;